// How often Engineer Dispatch re-reads the board.
// Long enough that the page is not fetching several times a second,
// short enough that an engineer's status shows without a manual refresh.
const STATUS_POLL_MS = 30000;

module.exports = { STATUS_POLL_MS };
